import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";


const MobileNav = ({ pathname }) => {
  const { getCurrentLogo } = useUserParams();
  const logoUrl = getCurrentLogo();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [headerPosition, setHeaderPosition] = useState(-100);
  const [headerTiming, setHeaderTiming] = useState(0.8);

  useEffect(() => {
    // Reset menu state when pathname changes
    setIsMenuOpen(false);
    setHeaderPosition(-100);
    document.body.style.overflow = "auto";
  }, [pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setHeaderPosition(isMenuOpen ? -100 : 0);
    document.body.style.overflow = !isMenuOpen ? "hidden" : "auto";
  };

  const navClick = () => {
    setHeaderPosition(-100);
    setHeaderTiming(0);
    setTimeout(() => {
      setHeaderTiming(0.8);
    }, 100);
    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "auto";
    }
  };

  const navItems = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About" },
    { href: "/calculator", label: "Mortgage Calculator" },
    { href: "/listings", label: "Listings" },
    { href: "/evaluation", label: "Free Home Evaluation" },
    { href: "/real-estate-reports", label: "Free Real Estate Reports" },
    { href: "/contact", label: "Contact" },
  ];

  return (
    <>
      <div className="relative w-full h-32 z-30 bg-gradient-to-r from-[#23272f]/80 via-[#18181b]/90 to-[#23272f]/80 backdrop-blur-lg grid sm:grid-cols-3 grid-cols-[1fr_50%_1fr] items-center shadow-2xl border-b border-[#23272f]/60">
        <div className="z-20 transition-opacity duration-700 ease-in-out w-full h-full absolute bg-transparent" />
        <button
          onClick={toggleMenu}
          className="z-30 text-2xl px-4 text-white cursor-pointer hover:text-white transition-colors duration-300"
        >
          <FontAwesomeIcon
            icon={isMenuOpen ? faXmark : faBars}
            className="w-6 h-6 drop-shadow-[0_0_8px_#ffffff] animate-pulse"
          />
        </button>
        <div className="flex justify-center">
          <img
            src={logoUrl}
            alt="Logo"
            width={96}
            height={96}
            className="z-30 h-24 drop-shadow-[0_0_16px_#ffffff] animate-pulse"
            style={{ filter: "drop-shadow(0 0 16px #ffffff)" }}
          />
        </div>
      </div>

      <nav
        style={{
          transition: `translate ${headerTiming}s cubic-bezier(0, .52, 0, 1)`,
          translate: `${headerPosition}vw`,
        }}
        className={`flex flex-col gap-12 px-6 py-9 fixed z-40 w-[75%] h-full top-0 left-0 bg-gradient-to-br from-[#23272f]/95 via-[#18181b]/95 to-[#23272f]/95 backdrop-blur-lg shadow-2xl border-r border-[#23272f]/60 child:tracking-wider child:font-bold transition-all duration-700 ${
          isMenuOpen ? "animate-slideInRight" : ""
        }`}
      >
        {navItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            onClick={navClick}
            className={`transition-all duration-300 text-white text-lg rounded-lg px-2 py-1 ${
              window.location.pathname === item.href
                ? "bg-white/20 text-white drop-shadow-[0_0_8px_#ffffff]"
                : "hover:text-white hover:drop-shadow-[0_0_8px_#ffffff] hover:bg-white/10"
            }`}
          >
            {item.label}
            {window.location.pathname !== item.href && (
              <FontAwesomeIcon
                className="pl-4 w-4 h-4 inline-block text-white group-hover:text-white transition-colors duration-300"
                icon={faAngleRight}
              />
            )}
          </Link>
        ))}
      </nav>
    </>
  );
};

export default MobileNav;
